/* Mapping Category icon  */
export const categoryIconMapper = category => {
    let svgName = category.toLowerCase()
	if (svgName.indexOf('expenses') !== -1) svgName = svgName.replace('expenses_', '')
	if (svgName.indexOf('income') !== -1) svgName = svgName.replace('income_', '')

    const categoryIcons = {
        food: 'food',
        automotive_transportation: 'transports',
        house: 'house',
        miscellaneous: 'pig',
        education: 'education',
        recreation: 'leisure',
        tourism: 'hotel',
        health_personal_care: 'health',
        clothing_footwear: 'clothing',
        communication: 'comunication',
        withdrawal: 'money',
        animals: 'animal',
        finance: 'finance',
        travel: 'trip',
        consumer_goods: 'cart',
        professional: 'briefcase',
        insurance: 'safe',
        sports: 'sport',
        taxes: 'trending-up',
        investment: 'coin-drop',
        transfer: 'transfer',
        credit: 'bills',
        deposit: 'money-bag',
        interest_commissions: 'percent',
        uncategorized: 'brokenImage',
        salary: 'wallet',
        rent: 'rent',
        public_service: 'public-service'
    }

    return categoryIcons[svgName]
}
